import { render, staticRenderFns } from "./chooseGoodsCategory.vue?vue&type=template&id=51e7955e"
import script from "./chooseGoodsCategory.vue?vue&type=script&lang=js"
export * from "./chooseGoodsCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports